<template>
	<Layout :pageTitle="'Retiros'">
		<!-- <template #cta>
			<router-link tag="a" to="/events/create" class="btn btn-primary">Crear evento</router-link>
		</template> -->
		<template #bar>
			<div class="filters-box justify-content-between">
				<div class="filter">
					<div class="filter-input">
						<i class="icon icon-search"></i>
						<input
							type="text"
							class="form-control"
							placeholder="Buscar en retiros"
							v-model="filters.search"
							@keyup.enter="updateFilters($event)"
						/>
						<div
							class="btn btn-light btn-clear-filter"
							v-if="filters.search"
							@click="
								filters.search = null
								updateFilters()
							"
						>
							<i class="icon icon-close"></i>
						</div>
					</div>
				</div>
			</div>
		</template>

		<Loader :show="loading" type="inline" />

		<div class="main-container container p-3" v-if="!loading">
			<div
				class="alert alert-info"
				v-if="accountDashboard && accountDashboard.account && accountDashboard.account.bankAccounts.length == 0"
			>
				<div>
					<h5>No tienes una cuenta bancaria configurada</h5>
					<p>Para poder retirar dinero, debes configurar al menos una cuenta bancaria</p>
				</div>
				<div>
					<router-link tag="a" to="/settings/bank-accounts" class="btn">Agregar cuenta bancaria</router-link>
				</div>
			</div>

			<div class="row row-xs">
				<div class="col col-md-4">
					<div class="card">
						<div class="card-body">
							<div class="p-2 ">
								<div class="label">Dinero disponible</div>
								<h2>
									{{ accountDashboard.account.currencySymbol }}
									{{ accountDashboard.released | toCurrency }}
								</h2>
								<p class="text-secondary">
									A liberar
									{{ accountDashboard.account.currencySymbol }}
									{{ accountDashboard.toRelease | toCurrency }}
								</p>
								<hr />
								<router-link tag="a" to="/withdraws/request" class="btn btn-block btn-secondary"
									>Retirar dinero</router-link
								>
							</div>
						</div>
					</div>
				</div>
				<div class="col col-md-8">
					<div class="card" v-if="list.length > 0">
						<div class="card-body">
							<table class="table table-clickeable">
								<tr class="table-head">
									<td>Fecha de solicitud</td>
									<td>Banco</td>
									<td class="text-right">Monto</td>
								</tr>

								<tr v-for="item of list" :key="item.id">
									<td>
										<div class="tc">
											<span>{{ item.createdAt | moment("DD-MM-YYYY HH:mm") }}</span>

											<span class="d-flex justify-content-end">
												<i class="dot mt-1 mr-1" :class="`dot-${item.statusClass}`"></i>
												<span>{{ item.statusText }}</span>
											</span>
										</div>
									</td>
									<td>
										<div class="tc">
											<span class="bolder">{{ item.bank.name }} </span>
											<span class="text-secondary"
												>{{ item.bankAccountType }} {{ item.bankAccountNumber }}</span
											>
										</div>
									</td>
									<td>
										<div class="tc text-right">
											<span class="bolder"
												>{{ item.currencySymbol }} {{ item.total | toCurrency }}</span
											>
										</div>
									</td>
								</tr>
							</table>

							<Pagination :pageData="pagination" @pageChange="pageChange" />
						</div>
					</div>

					<div class="alert alert-default" v-if="list.length <= 0">
						Aún no tienes retiros realizados
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "Transactions",
	data() {
		return {
			list: [],
			accountDashboard: {},
			loading: true
		}
	},
	beforeMount() {
		this.filters = this.getValidUrlParams()
		this.load()
	},
	methods: {
		load() {
			this.loading = true
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $search: String, $status: String) {
							withdraws(take: $take, skip: $skip, search: $search, status: $status) {
								data {
									id
									currencySymbol
									total
									bank {
										id
										name
									}
									bankAccountType
									bankAccountNumber

									createdAt
									status
									statusText
									statusClass
								}
								pageInfo {
									totalItems
								}
							}
							accountDashboard {
								account {
									currencySymbol
									bankAccounts {
										id
										name
									}
								}
								released
								commissionAccount
								toRelease
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						search: this.filters.search
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.list = data.withdraws.data
					this.pagination.pageInfo = data.withdraws.pageInfo
					this.accountDashboard = data.accountDashboard
					this.loading = false
				})
				.catch((err) => {
					this.loading = false
				})
		}
	}
}
</script>

<style></style>
